module.exports = __webpack_public_path__ + "static/media/splash.62fb7a71.jpg";